import React, { Component } from "react";
import _ from "lodash";
import { FormControlLabel, Checkbox, Button, Tooltip, Typography, Dialog, DialogActions, DialogContent, DialogTitle, Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ClearIcon from '@material-ui/icons/Clear';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RemoveIcon from '@material-ui/icons/Remove';
import TimePicker from "./timepicker"; 
import moment from 'moment'
import DropZone from "./dropZone";

class ExceptionDayPanel extends Component {
    constructor(props) {
      super(props);
      this.state = {
        item: props.item,
        fromInput: '',
        toInput: '', 
        addMore: false,
        showExc: false,
        isFullDay: props.item.is24Hours,
        isOpen: props.item.isOpen,
        confirmed: false,
        openConfirmation: false,

        isCloseDayConfirmation: false,
        confirmedClosed: false,
        tempData: [],

        openDeleteException: false,
      }
    }

    handleOpeningHoursDroppedData = (e) => {
      this.props.droppedData(e);
    }

    onAddViaDrop = (e) => {
      if( e.item && e.dragData.from !== '' && e.dragData.to !== '' ){
        const res = this.props.onAddViaDrop(e.item, e.dragData.from, e.dragData.to);
        if ( res > 0 ){
          this.setState({ addMore: true }, () => {
            this.setState({ addMore: false })
          });
        }
      }
    } 

    onAdd = (e) => {
      if( this.state.fromInput !== '' && this.state.toInput !== '' ){
        const res = this.props.onAddExcHour(this.state.item, this.state.fromInput, this.state.toInput);
        if( res > 0 ){
          this.setState({ addMore: false })
          this.state.fromInput = "";
          this.state.toInput = "";
          this.setState({ fromInput: '', toInput: '', tempData: [] });
        }
      }
    }

    onRemove = (item) => {
      this.props.onDelExc(item);
    }
 
    onShowTiming = (arr) => {
      return this.props.onShowHours(arr);
    }

    handleConfirmation = (checked, idx) => {
      if( this.state.confirmedClosed === true ){
        this.setState({ isCloseDayConfirmation: false, isOpen: false }, function(){
          // if checkbox is confirmed `unchecked`
          this.setOpen(checked, idx);

          // reset
          this.setState({ confirmedClosed: false, tempData: [] });
        })
      }else{
        this.setState({ isOpen: true }, function(){
          this.setOpen(checked, idx); 
        });
      }
    }

    handle24HoursConfirmation = (item, checked) => {  
      if( this.state.confirmed === true ){
        this.setState({ openConfirmation : false, confirmed: false }, () => {
          this.setState({ isFullDay: checked })
          this.props.setExcFull(item, checked);
        }) 
      }else{
        if( checked !== true ){
          this.setState({ openConfirmation: false })
        }else{
          this.setState({ confirmed: false })
        }

        this.setState({ isFullDay: false })
        this.props.setExcFull(item, false);
      }
    }

    setOpen = (item, checked) => {
      this.setState({ isOpen: checked })
      this.props.setExcOpen(item, checked);
    }

    onInputChange = (e) => {
      this.setState({ [e.target.name]: e.target.value }, () => this.onAdd(e));
    }

    onShowForm = () => {
      let arr = this.state.item.hours
      return (
        <div className="col">
            <div style={{ margin: '10px 0 20px 0', borderTop: '1px dotted #939393', borderBottom: '1px dotted #939393' }}>
              <FormControlLabel
                control={
                <Checkbox checked={this.state.isFullDay}
                    onChange={
                      () => { this.setState({ openConfirmation: true }, () => this.setState({ tempData: [this.state.item, !this.state.isFullDay] })); 
                        this.handle24HoursConfirmation(this.state.item, !this.state.isFullDay); 
                      }
                    }
                    color="primary"
                    name="name" />}
                label="24 Hours" 
                style={{ marginLeft: '0px' }}
              />
            </div>

            {arr.length > 0 ? (
              <div>
                {this.onShowTiming(this.state.item)}
              </div>
            ) : ('')}
            <div>
                {!this.state.isFullDay && this.state.addMore ? (
                  <div className="row" style={{ paddingLeft: "15px", paddingBottom: "15px" }}>
                    <TimePicker placeholder="From" defaultValue={this.state.fromInput} name="fromInput" pushData={(e) => { this.onInputChange(e) }}  isDisabled={false}/>  &nbsp;<RemoveIcon style={{ marginTop: "20px" }} />&nbsp;
                    <TimePicker placeholder="To" defaultValue={this.state.toInput} name="toInput" pushData={(e) => { this.onInputChange(e) }}  isDisabled={false}/> 

                    {/*<Tooltip title="Add">
                      <AddCircleIcon style={{ cursor: "pointer", marginTop: "20px", marginLeft: "5px" }} onClick={e => this.onAdd(e)} />
                    </Tooltip> */}

                    <Tooltip title="Cancel">
                      <ClearIcon style={{ cursor: "pointer", marginTop: "20px", marginLeft: "5px" }} onClick={e => this.setState({ addMore: false })} />
                    </Tooltip>
                  </div>
                ) : ('')}
            </div>
            {!this.state.isFullDay && !this.state.addMore ? (
              <div>
                <Button style={{ marginTop: 10 }} onClick={() => { this.setState({ addMore: true }) }}>{arr.length > 0 ? ('Add More Hours') : ('Add A New Opening Hour')}</Button>
              </div>
            ) : ('')}
            <div>
              <hr/>
              <Button className="mt-3" style={{ color: "red" }} onClick={() => { this.setState({ openDeleteException: true })  }}>Delete Exception</Button> {/*this.onRemove(this.state.item)*/}
            </div>
        </div>
      )
    }

    render() {
        return (
          <>
            <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-label="Expand"
                  aria-controls="additional-actions-content"
                  id="additional-actions-header">
                  <FormControlLabel
                    aria-label={this.state.item.date}
                    onClick={(event) => event.stopPropagation()}
                    onFocus={event => event.stopPropagation()}
                    control={<Checkbox checked={this.state.isOpen} onChange={() => { 

                      if( this.state.isOpen === false ){
                        this.handleConfirmation(this.state.item, !this.state.isOpen);
                      }else{
                        this.setState({ isCloseDayConfirmation: true, tempData: [this.state.item, !this.state.isOpen] }) 
                      }

                      //this.setOpen(this.state.item, !this.state.isOpen) 
                    }} color="primary"/> }
                    label={ moment( moment( this.state.item.date, 'DD-MM-YYYYTHH:mm:ssZ').toDate() ).format("dddd, D MMMM YYYY")}
                  />
                </AccordionSummary>

                { this.state.isOpen === true && this.state.isFullDay === false && <DropZone targetKey={ moment( moment( this.state.item.date, 'DD-MM-YYYYTHH:mm:ssZ').toDate() ).format("dddd, D MMMM YYYY") } idx={this.state.idx} fromInputKey={ this.state.fromInput } toInputKey={ this.state.toInput } exceptionItem={this.state.item} dropToDayData={(e) => { this.onAddViaDrop(e) }}  /> }

                <AccordionDetails>
                  <Typography />
                  {this.state.isOpen ? (
                    <div style={{ width: '100%' }}>
                      {this.onShowForm()}
                    </div>) :
                    (<div>
                      <div>
                        <i>Closed on {this.state.item.date}</i>
                      </div><br />
                      <div>
                        <Button style={{ color: "red" }} onClick={() => { this.setState({ openDeleteException: true }) }}>Delete Exception</Button> { /*this.onRemove(this.state.item)*/ }
                      </div>
                    </div>
                    )}
                </AccordionDetails>
            </Accordion> 
            
            <Dialog fullWidth={true} open={this.state.openDeleteException} onClose={() => { this.setState({ openDeleteException: false }) }} aria-labelledby="form-dialog-title">
              <DialogTitle id="form-dialog-title">Delete this exception?</DialogTitle>
              <DialogContent><h3 style={{ color: '#f50057' }}>{moment( moment( this.state.item.date, 'DD-MM-YYYYTHH:mm:ssZ').toDate() ).format("dddd, D MMMM YYYY")}</h3> This exception date will be removed, including the current timings under it.</DialogContent>
              <DialogActions style={{ marginRight: '20px', marginBottom: '20px' }}>
                <Button color="primary" variant="contained" style={{ cursor: "pointer" }} onClick={() => { this.onRemove(this.state.item) }}>Delete</Button>
                <Button color="secondary" variant="contained" onClick={() => { this.setState({ openDeleteException: false }) }} >Cancel</Button>
              </DialogActions> 
            </Dialog>

            <Dialog fullWidth={true} open={this.state.openConfirmation} onClose={() => { this.setState({ openConfirmation: false }) }} aria-labelledby="form-dialog-title">
              <DialogTitle id="form-dialog-title">Are you sure?</DialogTitle>
                <DialogContent>All the current timings below on this day scheduled will be removed</DialogContent>
              <DialogActions style={{ marginRight: '20px', marginBottom: '20px' }}>
                <Button color="primary" variant="contained" style={{ cursor: "pointer" }} onClick={() => { this.setState({ confirmed: true }, () => { 
                  this.handle24HoursConfirmation( this.state.tempData[0], this.state.tempData[1] );}) }}>Update</Button>
                <Button color="secondary" variant="contained" onClick={() => { this.setState({ openConfirmation: false, confirmed: false }) }} >Cancel</Button>
              </DialogActions> 
            </Dialog> 

            <Dialog fullWidth={true} open={this.state.isCloseDayConfirmation} onClose={() => { this.setState({ isCloseDayConfirmation: false }) }} aria-labelledby="form-dialog-title">
              <DialogTitle id="form-dialog-title">Are you sure?</DialogTitle>
                <DialogContent>All the current timings below on this day scheduled will be removed.</DialogContent>
              <DialogActions style={{ marginRight: '20px', marginBottom: '20px' }}><Button color="primary" variant="contained" style={{ cursor: "pointer" }} onClick={() => { this.setState({ confirmedClosed: true }, () => { this.handleConfirmation( this.state.tempData[0], this.state.tempData[1] ); }) }}>Update</Button>
                <Button color="secondary" variant="contained" onClick={() => { this.setState({ isCloseDayConfirmation: false,  confirmedClosed: false }) }} >Cancel</Button>
              </DialogActions> 
            </Dialog> 
          </>
        )
    }
}

export default ExceptionDayPanel;